<template>
    <form id="kt_modal_new_target_form" @submit.prevent="submitMethod(formName)" class="form" >
        <RequiredText />
        <div class="d-flex flex-column mb-8 fv-row">
            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required" >{{$t('department.departmentName')}} </span>
            </label>
            <input type="text" required class="form-control form-control-solid required" placeholder="ex: Marketing" v-model="formName" />
        </div>
        <div class="modal-footer">
          <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
        </div>
    </form>
</template>

<script setup>

import {ref, watch} from "vue"
import RequiredText from "@/components/RequiredText.vue"
import Button from "@/components/Button"

const props = defineProps({
    submitMethod:Function,
    name:String,
    isLoading:{
        type:Boolean,
        default:false
    },
    resetForm:Boolean
})

const formName = ref(props.name)

watch(() => props.resetForm, (newVal) => {
  if(props.resetForm){
      formName.value =""
  }
})


watch(() => props.name, (newName) => {
  formName.value = newName
})


</script>